import { useUserStore } from 'hooks/stores/useUserStore';
import Script from 'next/script';
import { useEffect } from 'react';

const RedditPixel = () => {
  const userStore = useUserStore();

  useEffect(() => {
    if (window.rdt) {
      const emailAddress = userStore.currentUser?.emailAddress;
      const params: Record<string, unknown> = {};
      if (emailAddress) {
        params['email'] = emailAddress;
      }
      if (userStore?.currentUser?.id) {
        params['externalId'] = userStore?.currentUser?.id;
      }
      window.rdt('track', 'PageVisit', params);
    }
  }, []);

  return (
    <Script id="redditPixel">
      {`
      !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js?pixel_id=a2_j5l5a5p9gfsb",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_j5l5a5p9gfsb');
    `}
    </Script>
  );
};

export default RedditPixel;
